import { Box, Button, IconButton } from "@mui/material";
import { palette } from "../../themes/theme";
import { useState } from "react";
import DarkPrimaryButton from "../PrimaryButton/DarkPrimaryButton";
import { CustomDraggable } from "../Draggable";

export const ShapeSelector = ({ mapRef, handleClose, setShapeSettings }) => {
  const [active, setActive] = useState(0);
  const [iconNames] = useState([
    { value: "Square", key: "fa-sharp fa-solid fa-square" },
    { value: "Circle", key: "fa-sharp fa-solid fa-circle" },
    { value: "Triangle", key: "fa-sharp fa-solid fa-triangle" },
    { value: "Comment", key: "fa-sharp fa-solid fa-comment" },
    { value: "Hexagon", key: "fa-sharp fa-solid fa-hexagon" },
  ]);

  return (
    <CustomDraggable
      width={230}
      height={210}
      headerTitle={"Select Shape"}
      customFooter={
        <Button variant="outlined" sx={{ fontWeight: "bold" }} onClick={handleClose}>Close</Button>
      }
    >
      <Box
        sx={{
          pt: 1,
          overflow: "auto",
          flexWrap: "wrap",
        }}
      >
        {iconNames.map((d, idx) => {
          // const IconComponent = MuiIcons[d];
          return (
            <IconButton
              key={idx}
              sx={{
                p: 1,
                height: 37,
                border: `1px solid ${palette.text.dark}`,
                borderRadius: 1,
                m: "4px",
                ...(active === idx
                  ? {
                      background: palette.primary.main,
                      color: palette.background.light,
                    }
                  : {
                      background: "black",
                      color: "white",
                    }),
                "&:hover": {
                  background: palette.primary.main,
                  color: palette.secondary.main,
                },
              }}
              onClick={() => {
                setActive(idx);
                setShapeSettings((previousValue) => {
                  previousValue.addSelectedShapeFlag = d.key;
                  return previousValue;
                });
              }}
            >
              <i className={d.key}></i>
              {/* <IconComponent fontSize="medium" /> */}
            </IconButton>
          );
        })}
      </Box>
    </CustomDraggable>
  );
};
